import { render, staticRenderFns } from "./VasionSnackbar.vue?vue&type=template&id=44d6f2bc&scoped=true&"
import script from "./VasionSnackbar.vue?vue&type=script&lang=js&"
export * from "./VasionSnackbar.vue?vue&type=script&lang=js&"
import style0 from "./VasionSnackbar.vue?vue&type=style&index=0&id=44d6f2bc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44d6f2bc",
  null
  
)

export default component.exports